<template>
    <section class="card flex-container my-4">
        <div class="flex items-start justify-between flex-wrap gap-2">
            <div class="flex flex-col gap-y-2">
                <div class="flex items-center flex-wrap gap-2">
                    <img v-if="modulo.recebimentoFinalizado == 'S'" class="w-8 h-w-8" src="@/assets/check.png" alt="">
                    <img v-else class="w-7 h-w-7" src="@/assets/progress.png" alt="">
                    <h3 class="text-lg font-semibold">Checklist {{ modulo.localRealizacao }}</h3>
                    <Status :status="modulo.recebimentoFinalizado == 'S' ? 'preenchido' : 'pendente'" />
                </div>
                <div class="flex items-center flex-wrap">
                    <Icone :nome="'calendar_month'" />
                    <span class="">
                        {{ modulo.dataHorarioFinalizacao != '' ? modulo.dataHorarioFinalizacao : 'Checklist em progresso' }}
                    </span>
                </div>
            </div>
            <button v-if="modulo.recebimentoFinalizado == 'N'" @click="responderModulo"
                class="flex items-center float-end mr-4 mt-2 bg-azul-info text-white rounded-full py-1 px-4 shadow-md h-10 hover:ring-2 hover:ring-azul-claro cursor-pointer">
                Responder
            </button>
        </div>

        <div v-if="!modulo.pdfModulo"
            class="flex flex-col justify-center items-center border border-cinza-habilitado rounded-md my-4 mx-auto desktop:w-3/4">
            <img class="w-32 h-w-32 py-8" src="@/assets/pdf_gerando.gif" alt="">
            <div
                class="w-full flex gap-x-2 flex-wrap items-center py-2 px-2 border border-x-0 border-b-0 border-cinza-habilitado bg-cinza-desabilitado">
                <img class="w-6 h-w-6" src="@/assets/warning.png" alt="">
                <p class="font-medium">
                    {{ modulo.recebimentoFinalizado == 'S' ? 'Gerando PDF do Checklist ...' : 'PDF do Checklist em progresso' }}
                </p>
            </div>
        </div>

        <div v-else>
            <div
                class="h-full flex flex-col justify-center items-center border border-cinza-habilitado rounded-md my-4 mx-auto desktop:w-3/4">
                <VuePdf v-if="modulo.pdfModulo != ''" class="h-full" :src="modulo.pdfModulo" />
                <div
                    class="w-full py-2 pl-2 border border-x-0 border-b-0 border-cinza-habilitado bg-cinza-desabilitado">
                    <a class="flex gap-x-2 flex-wrap items-center justify-center text-azul-info cursor-pointer"
                        :href="modulo.pdfModulo" target="_blank">
                        <p class="font-medium">Abrir PDF do Checklist</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path
                                d="M1.33333 12C0.966667 12 0.652778 11.8694 0.391667 11.6083C0.130556 11.3472 0 11.0333 0 10.6667V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H6V1.33333H1.33333V10.6667H10.6667V6H12V10.6667C12 11.0333 11.8694 11.3472 11.6083 11.6083C11.3472 11.8694 11.0333 12 10.6667 12H1.33333ZM4.46667 8.46667L3.53333 7.53333L9.73333 1.33333H7.33333V0H12V4.66667H10.6667V2.26667L4.46667 8.46667Z"
                                fill="#1C1B1F" />
                        </svg>

                    </a>
                </div>
            </div>

            <div class="w-3/4 flex items-center justify-between mx-auto gap-x-4">
                <button @click="openModal('modalEmail')" class="botoes-envio">
                    <span class="material-symbols-outlined">
                        outgoing_mail
                    </span>
                    <p class="font-medium">Enviar por email</p>
                </button>
                <button @click="openModal('modalTelefone')" class="botoes-envio">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                        <g clip-path="url(#clip0_813_391)">
                            <path
                                d="M11.9009 2.5353C11.2592 1.88736 10.4948 1.37369 9.6525 1.02426C8.81017 0.674822 7.90668 0.496622 6.99475 0.500048C3.17362 0.500048 0.0595 3.6133 0.056 7.4353C0.056 8.65942 0.37625 9.8503 0.980875 10.9047L0 14.5L3.6785 13.5358C4.69568 14.0908 5.83603 14.3811 6.99475 14.3802H6.99825C10.8202 14.3802 13.9335 11.2669 13.937 7.44142C13.9378 6.52973 13.7582 5.62688 13.4086 4.78487C13.059 3.94287 12.5472 3.17833 11.9009 2.5353ZM6.99475 13.2059C5.96153 13.2051 4.94745 12.9271 4.05825 12.4009L3.84825 12.2749L1.666 12.8472L2.24875 10.7183L2.11225 10.4987C1.53458 9.58021 1.22907 8.51682 1.23112 7.4318C1.23112 4.25905 3.8185 1.6708 6.99825 1.6708C7.75577 1.66944 8.50607 1.81804 9.20589 2.10803C9.90571 2.39802 10.5412 2.82366 11.0757 3.36042C11.612 3.89518 12.0372 4.53077 12.3267 5.23058C12.6163 5.93039 12.7645 6.68058 12.7627 7.43792C12.7592 10.622 10.1719 13.2059 6.99475 13.2059ZM10.1579 8.88867C9.9855 8.80205 9.13412 8.38292 8.974 8.32342C8.81475 8.26655 8.69837 8.2368 8.58462 8.41005C8.46825 8.58242 8.13575 8.9753 8.036 9.08817C7.93625 9.20455 7.833 9.21767 7.65975 9.13192C7.48737 9.04442 6.92825 8.86242 6.26675 8.27005C5.7505 7.81067 5.40487 7.24192 5.30162 7.06955C5.20187 6.8963 5.292 6.80355 5.37862 6.71692C5.45475 6.63992 5.551 6.51392 5.63762 6.41417C5.72512 6.31442 5.754 6.24092 5.81087 6.12542C5.86775 6.00817 5.84062 5.90842 5.79775 5.8218C5.754 5.73517 5.40837 4.8803 5.26225 4.53555C5.12225 4.19517 4.97962 4.24242 4.87287 4.23805C4.77312 4.23192 4.65675 4.23192 4.54037 4.23192C4.4525 4.23416 4.36604 4.25451 4.28639 4.2917C4.20674 4.32889 4.13563 4.38211 4.0775 4.44805C3.91825 4.6213 3.47287 5.04042 3.47287 5.8953C3.47287 6.75017 4.09412 7.5718 4.18162 7.68817C4.26737 7.80455 5.40137 9.55367 7.14175 10.3062C7.553 10.4855 7.87675 10.5914 8.12962 10.6719C8.54525 10.8049 8.92062 10.7848 9.21987 10.7419C9.55237 10.6912 10.2445 10.3219 10.3906 9.9168C10.5341 9.5108 10.5341 9.1643 10.4904 9.09167C10.4475 9.01817 10.3311 8.9753 10.1579 8.88867Z"
                                fill="black" />
                        </g>
                        <defs>
                            <clipPath id="clip0_813_391">
                                <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                            </clipPath>
                        </defs>
                    </svg>
                    <p class="font-medium">Enviar por WhatsApp</p>
                </button>
            </div>
        </div>
    </section>

    <vs-modal ref="modalTelefone" backdropBlur title="Informe o número do telefone:">
        <div class="flex items-end gap-x-2">
            <input type="text" v-model="telefone" @input="mascaraTelefone" placeholder="(##) #####-####"
                inputmode="numeric"
                class="block border-preto-padrao w-3/4 py-1.5 pl-2 pr-20 text-gray-900 bg-white placeholder:text-gray-300 sm:text-sm sm:leading-6 focus:outline-none focus:border-azul-info border-b-2 border-solid hover:border-blue-500" />
            <button class="bg-verde-sucesso p-2 rounded-md text-white" @click="encaminharWpp">Enviar</button>
        </div>
    </vs-modal>

    <vs-modal ref="modalEmail" backdropBlur title="Informe o endereço de email:">
        <div class="flex items-end gap-x-2 top-0">
            <input type="email" v-model="email" @input="mascaraEmail" placeholder="email@email.com" inputmode="email"
                :disabled="exibirLoader"
                class="block border-preto-padrao w-3/4 py-1.5 pl-2 pr-20 text-gray-900 bg-white placeholder:text-gray-300 sm:text-sm sm:leading-6 focus:outline-none focus:border-azul-info border-b-2 border-solid hover:border-blue-500" />
            <button v-if="!exibirLoader" class="bg-verde-sucesso p-2 rounded-md text-white"
                @click="encaminharEmail">Enviar</button>
            <div v-else class="flex flex-col justify-center items-center gap-1">
                <Loader></Loader> <span class="text-sm">Enviando</span>
            </div>
        </div>
    </vs-modal>

</template>

<script>
/* eslint-disable vue/no-unused-components */
import { defineComponent } from 'vue'
import Icone from '@/components/Icone.vue'
import { VuePdf } from 'vue3-pdfjs';
import Status from '@/components/Status.vue';
import FuncoesHelper from '@/helpers/FuncoesHelper';
import Rotas from '@/router/Rotas';
import ComponenteModuloService from '@/services/componentes/ComponenteModuloService';
import VsModal from '@vuesimple/vs-modal';
import Actions from '@/store/Actions';
import Loader from '@/components/Loader.vue';

export default defineComponent({
    name: 'Modulo',
    components: {
        Icone,
        VuePdf,
        Status,
        VsModal,
        Loader
    },
    methods: {
        responderModulo() {
            FuncoesHelper.pushRouter(Rotas.ETAPAS.nome,
                {
                    identificador: this.identificador,
                    modulo: this.modulo.idChecklistModulo,
                    localRealizacao: this.modulo.localRealizacao.toLowerCase(),
                    etapa: 1
                }
            );
        },
        encaminharEmail() {
            if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email))) {
                FuncoesHelper.notificar('error', 'Atenção', 'Informe um email válido');
                this.error = true
                this.email = ''
                return;
            }
            this.exibirLoader = true;
            this.$store.dispatch(Actions.ENVIAR_EMAIL_PDF, {
                email: this.email,
                idChecklistModuloResposta: this.modulo.idChecklistModuloResposta,
                solicitante: this.dadosAtendimento.nomeSolicitante
            }).then(() => {
                FuncoesHelper.notificar('success', 'Sucesso', 'Email enviado com sucesso');
            }).catch(() => {
                FuncoesHelper.notificar('error', 'Erro', 'Erro ao enviar email');
            }).finally(() => {
                this.exibirLoader = false;
                this.closeModal('modalEmail');
            });
        },
        encaminharWpp() {
            const contato = '55' + this.telefone.replace(/\D/g, '');
            const assunto = encodeURIComponent(`Atendimento: ${this.dadosAtendimento.protocolo}\nPlaca do veículo: ${this.dadosAtendimento.placa}`);
            const mensagem = encodeURIComponent(`\n\nOlá,\nSegue o link para download do PDF do checklist do atendimento ${this.dadosAtendimento.protocolo}:\n\n${this.modulo.pdfModulo}`);
            let newURL = `https://api.whatsapp.com/send?phone=${contato}&text=${assunto}${mensagem}`;
            this.telefone = '';
            this.closeModal('modalTelefone');
            window.open(newURL, "_blank");
        },
        openModal(ref) {
            this.$refs[ref].open();
        },
        closeModal(ref) {
            this.telefone = '';
            this.email = '';
            this.$refs[ref].close();
        },
        mascaraTelefone() {
            this.telefone = this.telefone
                .replace(/\D/g, '')
                .match(/(\d{0,2})(\d{0,5})(\d{0,4})/)
                .slice(1)
                .filter(Boolean)
                .join('')
                .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        },
    },
    props: {
        modulo: {
            type: Object,
            required: true
        }
    },
    setup() {
        return ComponenteModuloService.setup();
    }
})
</script>

<style scoped>
.botoes-envio {
    @apply bg-cinza-desabilitado flex items-center flex-wrap gap-x-1 p-4 rounded-md w-full justify-center cursor-pointer border border-cinza-habilitado;
}
</style>